import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/vnv': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M104.9 352C70.8 352 58.5 321.6 58.5 321.6L2.6 210.1S-7.8 192 13 192H45.8C56.2 192 59 200.7 64.6 210.1L101.3 284.6S106.5 297.7 122.4 297.7 143.5 284.6 143.5 284.6L180.2 210.1C185.8 200.6 188.6 192 199 192H231.8C252.6 192 242.2 210.1 242.2 210.1L186.4 321.6S174.2 352 140 352H104.9zM499.9 352C465.8 352 453.5 321.6 453.5 321.6L397.6 210.1S387.2 192 408 192H440.8C451.2 192 454 200.7 459.6 210.1L496.3 284.6S501.5 297.7 517.4 297.7 538.5 284.6 538.5 284.6L575.3 210.1C580.9 200.6 583.7 192 594.1 192H627C647.8 192 637.4 210.1 637.4 210.1L581.5 321.6S569.3 352 535.1 352H499.9zM337.6 192C371.7 192 384 222.4 384 222.4L439.9 333.9S450.3 352 429.5 352H396.7C386.3 352 383.5 343.3 377.9 333.9L341.2 259.4S336 246.3 320.1 246.3C304.2 246.3 299 259.4 299 259.4L262.3 333.9C256.7 343.3 253.9 352 243.5 352H210.6C189.8 352 200.2 333.9 200.2 333.9L256.1 222.4S268.3 192 302.5 192H337.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/vnv.js
// module id = XW5+
// module chunks = 144